const storiesSwiper = new Swiper('.collection-stories__stories', {
  preloadImages: false,
  lazy: true,

  slidesPerView: 'auto',
  spaceBetween: 12,
  freeMode: true,
  breakpoints: {
    768: {
      spaceBetween: 28,
    },
  },
});

const collectionSwiper = new Swiper('.collection-combination__swiper', {
  slidesPerView: 'auto',
});

document.addEventListener('DOMContentLoaded', function () {
  const storyElements = document.querySelectorAll('.collection-stories__story');
  const combinationElements = document.querySelectorAll('.collection-combination');

  // Function to handle story click
  function handleStoryClick(story) {
    storyElements.forEach((story) => {
      story.classList.remove('active');
    });

    story.classList.add('active');

    const collectionId = story.getAttribute('data-collection-id');
    combinationElements.forEach((combination) => {
      if (combination.id === `collection-${collectionId}`) {
        combination.style.display = 'block';
      } else {
        combination.style.display = 'none';
      }
    });
  }

  storyElements.forEach((story) => {
    story.addEventListener('click', function () {
      handleStoryClick(this);
    });
  });

  // Automatically trigger a click event on the first story on page load
  if (storyElements.length > 0) {
    handleStoryClick(storyElements[0]);
  }
});
